import values from "../values";

import { Layout } from "../components";
import { NotFound } from "../screen";
import { Navigate, Route, Routes } from "react-router-dom";

import DriverContainer from "../screen/DriverScreen/container/Common.container";
import OrderContainer from "../screen/OrderScreen/container/Common.container";
import CategoryPriceClient from "../screen/CategoryPriceScreen/container/Company.container";
import WorkTimeContainer from "../screen/WorkTimeScreen/container/Company.container";
import AreaContainer from "../screen/AreaScreen/container/Company.container";
import TicketContainer from "../screen/TicketScreen/Container/Common.container";

const CompanyRoute = () => {
  let topMenu: any = values.topMenuItems.TOP_MENU_ROLE_COMPANY;

  return (
    <Layout topMenuItems={topMenu}>
      <Routes>
        <Route path="/" element={<Navigate to={"drivers"} />} />
        <Route path="/drivers/*" element={<DriverContainer />} />
        <Route path="/orders/*" element={<OrderContainer />} />
        {/* <Route path="/clients/*" element={<ClientContainer />} /> */}
        {/* <Route path="/categories/*" element={<CategoryClient />} /> */}
        <Route path="/update-price/*" element={<CategoryPriceClient />} />
        <Route path="/work-time/*" element={<WorkTimeContainer />} />
        <Route path="/area/*" element={<AreaContainer />} />
        <Route path="/ticket/*" element={<TicketContainer />} />
        {/* <Route path="/other/*" element={<OtherScreen />} /> */}
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
};

export default CompanyRoute;
